export default "__VITE_ASSET__BiohtSZc__"